export default __webpack_public_path__ + "static/media/Träslöjd6.fc4620cf.jpeg";